class Timeline extends elementorModules.frontend.handlers.Base {
  protected swiperInstance: any = null;

  constructor($element: JQuery, args: any) {
    console.log("Timeline run2");
    super($element, args);
    const asyncSwiper = elementorFrontend.utils.swiper;
    const swiperElement = this.elements.$swiperContainer;

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      grabCursor: true,
      pagination: {
        el: this.elements.$pagination[0],
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 32 },
        1200: { slidesPerView: 3, spaceBetween: 64 },
      },
      //on itinialise
      on: {
        init: function () {
          sameHeightTitles();
        },
        //when resize
        resize: function () {
          sameHeightTitles();
        },
      },
    };

    const sameHeightTitles = () => {
      // set the min-height of the item__title to the height of the tallest item__title.
      const titles = swiperElement[0].querySelectorAll(".item__title");
      if (titles) {
        let tallest = 0;
        titles.forEach((title: HTMLElement) => {
          title.style.minHeight = "0";
          const height = title.offsetHeight;
          if (height > tallest) {
            tallest = height;
          }
        });
        titles.forEach((title: HTMLElement) => {
          title.style.minHeight = `${tallest}px`;
        });
      }
    };

    //svg triangle with a white stroke on the right two edges
    var svgTemplate = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
        <polygon points="0,0 100,50 0,100" fill="white"/>
        <polygon points="0,5 80,50 0,95" fill="{{fillColor}}"/>
    </svg>
    `;

    this.colors = Array.from(
      document.querySelectorAll(".slide-inner[data-colour]")
    ).map((el) => {
      return el.getAttribute("data-colour");
    });

    const swiper = new asyncSwiper(swiperElement, swiperConfig).then(
      (swiper: any) => {
        this.swiperInstance = swiper;
        const background = this.createGradient(this.colors, 50);
        document.documentElement.style.setProperty("--timeline-bg", background);

        const slidesPerView = swiper.params.slidesPerView;

        if (this.colors.length >= slidesPerView) {
          this.updateArrowColour(svgTemplate, this.colors[slidesPerView]);
        }

        //@ts-ignore
        swiper.on("slideChange", (swiper: Swiper) => {
          document.documentElement.style.setProperty(
            "--timeline-bg-start",
            this.colors[swiper.activeIndex]
          );

          const slidesPerView = swiper.params.slidesPerView;
          console.log("slidesPerView", slidesPerView);

          const endColour =
            swiper.activeIndex + slidesPerView >= this.colors.length
              ? this.colors[this.colors.length - 1]
              : this.colors[swiper.activeIndex + slidesPerView];
          this.updateArrowColour(svgTemplate, endColour);
        });
      }
    );
  }

  updateArrowColour(svgTemplate: string, newFillColor: string) {
    // Replace '{{fillColor}}' in the SVG string with the new color
    var newSVGString = svgTemplate.replace("{{fillColor}}", newFillColor);

    // Encode the SVG string so it can be used in CSS
    var encodedSVG = encodeURIComponent(newSVGString);

    // Set the content property of the pseudo-element
    (document.querySelector(".swiper") as HTMLElement).style.setProperty(
      "--triangle-svg",
      `url('data:image/svg+xml;utf8,${encodedSVG}')`
    );
  }

  createGradient(colors: string[], transitionWidth: number) {
    if (colors.length < 2) {
      return "Length of colors array must be at least 2";
    }

    const width = 100 / (colors.length + 2);
    const transition = (transitionWidth * width) / 100;
    let gradient = "linear-gradient(to right, ";

    for (let i = -1; i < colors.length + 1; i++) {
      let color = colors[Math.min(Math.max(i, 0), colors.length - 1)];
      const start = (i + 1) * width + (i > -1 ? transition : 0);
      const end = (i + 2) * width - (i < colors.length ? transition : 0);
      gradient +=
        color +
        " " +
        start.toFixed(2) +
        "%, " +
        color +
        " " +
        end.toFixed(2) +
        "%";
      if (i !== colors.length) {
        gradient += ", ";
      }
    }

    gradient = gradient + ")";

    document.documentElement.style.setProperty(
      "--timeline-bg-start",
      colors[0]
    );

    return gradient;
  }

  getDefaultSettings() {
    return {
      selectors: {
        swiperContainer: ".swiper",
        swiperSlides: ".swiper-slide",
        timeline: ".hco-timeline__line",
        pagination: ".hco-timeline__pagination",
      },
    };
  }
  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $swiperContainer: this.$element.find(selectors.swiperContainer),
      $swiperSlides: this.$element.find(selectors.swiperSlides),
      $timeline: this.$element.find(selectors.timeline),
      $pagination: this.$element.find(selectors.pagination),
    };
  }
  bindEvents() {}
}

/**
 * Register JS Handler for the Test Widget
 *
 * When Elementor frontend was initiated, and the widget is ready, register the widet
 * JS handler.
 */
window.addEventListener("elementor/frontend/init", () => {
  elementorFrontend.elementsHandler.attachHandler(
    "gravitas_timeline",
    Timeline
  );
});
